import React from 'react';
import { Tabs, Empty } from 'antd';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RealtimeInvoicePoolOverviewPage from './RealtimeInvoicePoolOverviewPage';
import RealtimeInvoiceListPage from './RealtimeInvoiceListPage';

/**
 * 实时结算 Invoice 详情页：由客户列表页新开浏览器 Tab 进入，客户 ID 取自路由参数、名称取自 query 参数。
 * 含两个子 Tab（凭证池概览 / Invoice 列表）。
 */
const RealtimeInvoiceDetailPage: React.FC = () => {
    const { t } = useTranslation();
    const { settlementClientId } = useParams<{ settlementClientId: string }>();
    const [searchParams] = useSearchParams();
    const customerName = searchParams.get('name');

    if (!settlementClientId) {
        return <Empty />;
    }

    const items = [
        {
            label: t('settlement.realtimeInvoice.tabs.poolOverview'),
            key: 'pool-overview',
            children: <RealtimeInvoicePoolOverviewPage settlementClientId={settlementClientId} />,
        },
        {
            label: t('settlement.realtimeInvoice.tabs.invoiceList'),
            key: 'invoice-list',
            children: <RealtimeInvoiceListPage settlementClientId={settlementClientId} />,
        },
    ];

    return (
        <div>
            <div className="mb-4 flex items-center gap-3">
                <span className="font-medium">{customerName || settlementClientId}</span>
            </div>
            <Tabs items={items} destroyInactiveTabPane />
        </div>
    );
};

export default RealtimeInvoiceDetailPage;
